import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { getRiskDisplayLabel } from "@/lib/recallUtils";

interface RiskBadgeProps {
  riskType: string;
  motive?: string;
  className?: string;
}

export const RiskBadge = ({ riskType, motive, className }: RiskBadgeProps) => {
  const getRiskColor = (risk: string) => {
    switch (risk) {
      case 'listeria':
      case 'salmonella':
      case 'ecoli':
      case 'toxoplasma':
      case 'staphylococcus':
      case 'campylobacter':
      case 'clostridium_botulinum':
        return 'bg-destructive text-destructive-foreground';
      case 'mycotoxine_aflatoxine':
      case 'mycotoxine_ochratoxine':
      case 'pesticide_eto':
      case 'chimique_moah_pah':
      case 'clostridium_perfringens':
      case 'norovirus':
      case 'rotavirus':
      case 'pathogene_autre':
      case 'bacillus_cereus':
      case 'risque_autre':
        return 'bg-warning text-warning-foreground';
      case 'allergene':
        return 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200';
      case 'conditionnement':
        return 'bg-info text-info-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <Badge
      variant="secondary"
      className={cn(
        "text-xs font-medium",
        getRiskColor(riskType),
        className
      )}
    >
      {getRiskDisplayLabel(riskType, motive)}
    </Badge>
  );
};